export default {"src":"/_next/static/media/pick-return-arrow.fc793b1e.svg","height":182,"width":32,"blurWidth":0,"blurHeight":0};